import sileo from 'sileo';

const PersonalMilestones = new sileo.Model('hqzen', 'personal-milestones');
const SimplePersonalMilestone = new sileo.Model('hqzen', 'simple-personal-milestones');
const ClosedPersonalMilestone = new sileo.Model('hqzen', 'closed-milestone');
const PersonalMilestoneCards = new sileo.Model('hqzen', 'personal-milestone-cards');
const PersonalMilestoneMember = new sileo.Model('hqzen', 'personal-milestone-members');
const PersonalChallengeFormPrompt = new sileo.Model('hqzen', 'personal-challenge-form');
const PersonalMilestoneRequest = new sileo.Model('hqzen', 'personal-milestone-request');
const PersonalMilestoneContinuityCriterion = new sileo.Model('hqzen', 'personal-milestone-continuity-criteria');
const PersonalMilestoneRuleCriterion = new sileo.Model('hqzen', 'personal-milestone-rule-criteria');
const PersonalMilestoneColumns = new sileo.Model('hqzen', 'personal-milestone-columns');
const PersonalGoalMilestone = new sileo.Model('hqzen', 'personal-goal-milestones');

const actions = {
    getPersonalMilestone(context, pk) {
        return PersonalMilestones.objects.get(pk);
    },

    fetchPersonalMilestone(context, { filters, key }) {
        if (key === 'is-personal')
            return SimplePersonalMilestone.objects.filter(filters);
        else
            return PersonalMilestones.objects.filter(filters);
    },

    createPersonalMilestone(context, data) {
        const form = new FormData();
        for (let key in data) {
            if (key === 'continuity_criteria' || key === 'rule_criteria') {
                data[key] = JSON.stringify(data[key]);
            }
            form.append(key, data[key]);
        }

        return PersonalMilestones.objects.create(form);
    },

    getClosedPersonalMilestone(context, pk) {
        return ClosedPersonalMilestone.objects.get(pk);
    },

    fetchPersonalMilestoneCards(context, filters) {
        return PersonalMilestoneCards.objects.filter(filters);
    },

    getPersonalMilestoneMembers(context, filters) {
        return PersonalMilestoneMember.objects.filter(filters);
    },

    fetchUnansweredForm(context, filters) {
        return PersonalChallengeFormPrompt.objects.filter(filters);
    },

    createPersonalMilestoneRequest(context, filters) {
        return PersonalMilestoneRequest.objects.create(filters);
    },

    fetchPersonalMilestoneRequests(context, filters) {
        return PersonalMilestoneRequest.objects.filter(filters);
    },

    updatePersonalMilestoneRequest(context, data) {
        const form = new FormData();
        let pk = data.pk;

        form.append('status', data.status);
        form.append('rejection_reason', data.rejection_reason);
        form.append('personal_milestone', data.personal_milestone);
        form.append('user_profile', data.user_profile);
        form.append('start_date', data.start_date);
        form.append('end_date', data.end_date);
        form.append('form_document_assignment', data.form_document_assignment);

        return PersonalMilestoneRequest.objects.update({ 'pk': pk }, form);
    },

    updatePersonalMilestoneRequestPoints(context, data) {
        const form = new FormData();
        let pk = data.pk;

        form.append('status', data.status);
        form.append('milestone_point', data.milestone_point);

        return PersonalMilestoneRequest.objects.update({ 'pk': pk }, form);
    },

    createPersonalMilestoneContinuityCriterion(context, data) {
        const form = new FormData();
        form.append('milestone', data.milestone);
        form.append('duration', data.duration);
        form.append('description', data.description);

        return PersonalMilestoneContinuityCriterion.objects.create(form);
    },

    updatePersonalMilestoneContinuityCriterion(context, data) {
        const form = new FormData();
        let pk = data.pk;

        form.append('milestone', data.milestone);
        form.append('duration', data.duration);
        form.append('description', data.description);

        return PersonalMilestoneContinuityCriterion.objects.update({ 'pk': pk }, form);
    },

    deletePersonalMilestoneContinuityCriterion(context, filters) {
        return PersonalMilestoneContinuityCriterion.objects.delete(filters);
    },

    createPersonalMilestoneRuleCriterion(context, data) {
        const form = new FormData();
        form.append('milestone', data.milestone);
        form.append('description', data.description);

        return PersonalMilestoneRuleCriterion.objects.create(form);
    },

    updatePersonalMilestoneRuleCriterion(context, data) {
        const form = new FormData();
        let pk = data.pk;

        form.append('milestone', data.milestone);
        form.append('description', data.description);

        return PersonalMilestoneRuleCriterion.objects.update({ 'pk': pk }, form);
    },

    deletePersonalMilestoneRuleCriterion(context, filters) {
        return PersonalMilestoneRuleCriterion.objects.delete(filters);
    },

    fetchPersonalMilestoneColumns(context, data) {
        return PersonalMilestoneColumns.objects.filter(data).then(data => {
            return data;
        }).catch(e => {
            console.error('Error fetching personal milestone columns', e);
            return [];
        });
    },

    fetchPersonalGoalMilestone(context, filters) {
        return PersonalGoalMilestone.objects.filter(filters);
    },
};

export default {
    namespaced: true,
    actions
};
